const types = {
    IMAGES_REQUEST: 'images/IMAGES_REQUEST',
    IMAGES_REQUEST_COMPLETED: 'images/IMAGES_REQUEST_COMPLETED',
};

const createTypes = {
    ADD_IMAGE_REQUEST: 'images/ADD_IMAGE_REQUEST',
};

const deleteTypes = {
    DELETE_IMAGE_REQUEST: 'images/DELETE_IMAGE_REQUEST',
    DELETE_IMAGE_REQUEST_COMPLETED: 'images/DELETE_IMAGE_REQUEST_COMPLETED',
};

export default {
    ...types,
    ...createTypes,
    ...deleteTypes,
};
